module.exports = __webpack_public_path__ + "media/images/flags/16/South-Korea-7a3dca49125bdf2dc48d7c13d746f279.png";